/**
 * Converts a data rate in Mbps to a user-friendly string with appropriate units.
 *
 * If the value is less than 1000, it is rendered in Mbps.
 * If it is 1000 or more, it is rendered in Gbps.
 *
 * @param valueMpbs A value in Mbps.
 * @returns A formatted string including the appropriate unit.
 */
// export const formatDataRate = (valueMpbs: number): string => {
//     if (valueMpbs < 1000) {
//       return `${valueMpbs} Mbps`;
//     } else {
//       const gbps = valueMpbs / 1000;
//       // If the result is an integer, display without decimals,
//       // otherwise show one decimal place.
//       const formatted = gbps % 1 === 0 ? gbps.toFixed(0) : gbps.toFixed(1);
//       return `${formatted} Gbps`;
//     }
//   };

/**
 * If `n` is an integer, render e.g. "42".
 * Otherwise render exactly two decimals, e.g. "42.30".
 */
export const formatTwoOrInt = (n: number): string =>
  n % 1 === 0
    ? `${n}`
    : n.toFixed(2);

export function formatDataRate(valueMbps: number): string {
  const twoOrInt = (x: number) =>
    x % 1 === 0 ? x.toFixed(0) : x.toFixed(2);

  if (valueMbps < 1000) {
    return `${twoOrInt(valueMbps)} Mbps`;
  } else {
    return `${twoOrInt(valueMbps / 1000)} Gbps`;
  }
}

/**
 * Formats a number *valueMbps* as either “XXX Mbps” or “YYY Gbps”,
 * using 0 decimals for whole numbers and 2 decimals otherwise.
 */
export function formatDataRateSmart(valueMbps: number): string {
  // helper to render 0 or 2 decimal places
  const twoOrInt = (n: number): string =>
    n % 1 === 0 ? n.toFixed(0) : n.toFixed(2);

  if (valueMbps < 1000) {
    return `${twoOrInt(valueMbps)} Mbps`;
  } else {
    const gbps = valueMbps / 1000;
    return `${twoOrInt(gbps)} Gbps`;
  }
}

/**
 * Returns a normalized value and unit from a raw Mbps value.
 * If >= 1000 Mbps, returns Gbps.
 * Else returns Mbps.
 */
export function normalizeDataRate(valueMbps: number): {
  value: number;
  unit: "Gbps" | "Mbps";
} {
  if (valueMbps >= 1000) {
    return { value: valueMbps / 1000, unit: "Gbps" };
  } else {
    return { value: valueMbps, unit: "Mbps" };
  }
}

  